import { ajaxCall } from "@/shared/connection/ajax-call";

const TIMER_ENDPOINT = `/timers`;

export const timerService = {
    getAllLanguagesLabels() {
        return ajaxCall.get(`${TIMER_ENDPOINT}/labels`).catch((e) => {
            console.error(e);
        });
    },
};
